import { Component } from '@angular/core';
import { environment } from "../environments/environment";
//import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { AngularFireMessaging } from '@angular/fire/messaging';
import { MessagingService } from './shared/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  message:any;
  constructor(private afMessaging: AngularFireMessaging,private messagingService: MessagingService) {}

  ngOnInit() {

    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage
    
  }

  requestPermission() {
    this.afMessaging.requestPermission.subscribe(
      () => {
        console.log('Permission granted!');
        // Handle successful permission grant
      },
      (error) => {
        console.log('Permission denied:', error);
        // Handle permission denied or error
      }
    );
  }
}

       
